import type { ConfiguratorComposition } from "./ConfiguratorComposition";

const compositions = new WeakMap<object, ConfiguratorComposition>();

export function registerConfiguratorComposition(
  owner: object,
  composition: ConfiguratorComposition,
): void {
  compositions.set(owner, composition);
}

export function unregisterConfiguratorComposition(owner: object): void {
  compositions.delete(owner);
}

export function getConfiguratorComposition(
  owner: object,
): ConfiguratorComposition | undefined {
  return compositions.get(owner);
}
